import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class VehiclesAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'VEHICLE_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'VEHICLE_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'VEHICLE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'VEHICLE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteOneSuccess(vehicle) {
    const message = {
      body: 'X_VEHICLE_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, vehicle)
  }

  deleteOneError() {
    const message = {
      body: 'VEHICLE_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD DRIVER //
  addDriverSuccess() {
    const message = {
      body: 'VEHICLE_ADD_DRIVER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addDriverError() {
    const message = {
      body: 'VEHICLE_ADD_DRIVER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.vehicles')
  .service('vehiclesAlerts', VehiclesAlerts);
